import { render, staticRenderFns } from "./Geomatch.vue?vue&type=template&id=0029ae3c&scoped=true&"
import script from "./Geomatch.vue?vue&type=script&lang=js&"
export * from "./Geomatch.vue?vue&type=script&lang=js&"
import style0 from "./Geomatch.vue?vue&type=style&index=0&id=0029ae3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0029ae3c",
  null
  
)

export default component.exports